// Actions relating to users
export const MODAL_TYPE = 'MODAL_TYPE';
export const ALERT_TYPE = 'ALERT_TYPE';
export const USER_TYPE = 'USER_TYPE';
export const VEHICLE_TYPE = 'VEHICLE_TYPE';
export const START_TYPE = 'START_TYPE';
export const RESERVE_TYPE = 'RESERVE_TYPE';
export const SIGNMODAL_TYPE = 'SIGNMODAL_TYPE';
export const LOGOUT_ACTION = 'LOGOUT_ACTION';
export const PACKAGES_TYPE = 'PACKAGES_TYPE';
export const CONFIG_TYPE = 'CONFIG_TYPE';
export const NOTICE_TYPE = 'NOTICE_TYPE';
export const VEHICLESLIST_TYPE = 'VEHICLESLIST_TYPE';
export const MAP_TYPE = 'MAP_TYPE';
export const URL_TYPE = 'URL_TYPE';
export const DEEP_LINK = 'DEEP_LINK';
export const MODAL_SET_ID = 'MODAL_SET_ID';
export const ALERT_SET_ID = 'ALERT_SET_ID';
export const INTERNAL_CLOCK = 'INTERNAL_CLOCK';
export const ROOT_MODAL = 'ROOT_MODAL';
export const SHEET_SET = 'SHEET_SET';
export const APP = 'APP';
